// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3sbSH","footer":"ModalFilter_footer__3dxye"};